import Vue from "vue";
import Router from "vue-router";
import Plan from "./views/Plan.vue";
import ShoppingList from "./views/ShoppingList.vue";
import Recipes from "./views/Recipes.vue";
import Settings from "./views/Settings.vue";
import PrivacyStatement from "./views/PrivacyStatement.vue";
const Debug = () => import(/* webpackChunkName: "debug" */ "./views/Debug.vue");

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      redirect: () => localStorage.getItem("latestRoute") || "/list",
    },
    {
      path: "/recipes",
      name: "recipes",
      component: Recipes,
    },
    {
      path: "/plan",
      name: "plan",
      component: Plan,
    },
    {
      path: "/list",
      name: "shoppinglist",
      component: ShoppingList,
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
    },
    {
      path: "/privacy",
      name: "privacy",
      component: PrivacyStatement,
    },
    {
      path: "/debug",
      name: "debug",
      component: Debug,
    },
  ],
});

export default router;
